import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DwMenu, DwMenuService, DwMetaDataRoutingNavigationService, DwSecurityUserService, DwUser, DwMenuActionType, DwMenuCategory, DwControlType, DwSecurityOrchestrationService, DwActionExecutionService, DwActionState, DwMetaDataRoutingService } from '@devwareapps/devware-cap';
import { Subscription } from 'rxjs/internal/Subscription';
import { combineLatest, Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { PilexosUser } from '../../../shared/models/pilexos-user.model';
import { PilexosUserTypeIds } from '../../../shared/models/pilexos-user-type.enum';
import { AppPermissions } from '../../../../meta-data/app-permissions.enum';
import { AdminManagerService } from '../../../shared/services/admin-manager.service';
import { AppMetaDataItemNames } from '../../../../meta-data/app-meta-data.service';

@Component({
  selector: 'app-authenticated-home-view',
  templateUrl: './authenticated-home-view.component.html',
  styleUrls: ['./authenticated-home-view.component.scss']
})
export class AuthenticatedHomeViewComponent implements OnInit, OnDestroy {
  user: DwUser;
  textboxControlType: DwControlType = DwControlType.Textbox;
  pilexosUser: PilexosUser;

  adminView: string = 'examiner';
  readonly PilexosUserTypeIds = PilexosUserTypeIds;
  isPilexosAdmin: boolean;
  isFlightSchoolUser = false;
  // A new identity recreates the home and its scoped contexts on every security change.
  homeViewInstances: object[] = [];
 
  constructor(private router: Router,
    private dwMenuService: DwMenuService,
    private dwSecurityUserService: DwSecurityUserService,
    private dwMetaDataRoutingNavigationService: DwMetaDataRoutingNavigationService,
    private dwSecurityOrchestrationService: DwSecurityOrchestrationService,
    private dwActionExecutionService: DwActionExecutionService,
    private adminManagerService: AdminManagerService,
     private metaDataRoutingService: DwMetaDataRoutingService,
  ) { 

    //this.pilexosUser.UserTypeId == PilexosUserTypeIds.pilotExaminer
  }



  subscriptions: Subscription[] = [];

  ngOnInit(): void {
    // Match the app shell: allow security-derived user/cache state to settle first.
    this.subscriptions.push(this.dwSecurityUserService.securityContextChanged().pipe(delay(10)).subscribe((result) => {
      this.setupSecurity();
    }));

    this.setupSecurity();

  }

  ngOnDestroy(): void {
    // unsubscribe from all 
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  private setupSecurity() {
    if (!this.dwSecurityUserService.securityState.isAuthenticated || this.dwSecurityUserService.securityState.isAuthenticating) {
      this.homeViewInstances = [];
      this.pilexosUser = null;
      this.isFlightSchoolUser = false;
      this.isPilexosAdmin = false;
      return;
    }

    this.pilexosUser = this.adminManagerService.getPilexosUser();

    this.isPilexosAdmin = this.dwSecurityUserService.hasPermission(AppPermissions.pilexosAdmin);

    const schoolUserTypes = [PilexosUserTypeIds.flightSchool, PilexosUserTypeIds.checkInstructor, PilexosUserTypeIds.flightInstructor];

    this.isFlightSchoolUser = schoolUserTypes.includes(this.pilexosUser.UserTypeId);
    // Destroying the previous home cancels its requests via ngOnDestroy/takeUntil,
    // including task, card, feature and KPI loads for the previous school.
    this.homeViewInstances = [{}];
  }



  
    showSchoolRequestForm() {
     
       this.metaDataRoutingService.openAddEditViewModal(DwMenuActionType.add, AppMetaDataItemNames.FlightSchoolSetupRequest, null, null, null, 'sales-request')
          .subscribe(result => {
              if (!result.cancelled) {
                 
              }
          });
    }

}
